const getNumber = (number, oldMax, newMax) =>
(number * oldMax) / newMax


export default getNumber;
